export const COMMON_HELP_POPUP_BUTTON_CLASSNAME = 'help-popup-btn';

export const Color = {
    BLUE: 'blue',
    GREY: 'grey',
    GREEN: 'green',
    ORANGE: 'orange',
    DARK_GREY: 'dark-grey',
    RED: 'red',
};

export const Size = {
    SMALL: 'small',
    NORMAL: 'normal',
    LARGE: 'large',
    GIANT: 'giant',
};

export const Dim = {
    NONE: 'none',
    CENTER: 'center',
    FULL: 'full',
};

export const SPINNER = {
    DEFAULT: {
        length: 28,
        width: 14,
        radius: 42,
        color: '#fff',
        shadow: true,
    },
    DARK: {
        length: 28,
        width: 14,
        radius: 42,
        color: '#4c4c4c',
        shadow: true,
    },
    DARK_SMALL: {
        lines: 8,
        length: 0,
        width: 18,
        radius: 30,
        color: '#717171',
    },
};

export const Direction = {
    LTR: 'ltr',
    RTL: 'rtl',
};
